@let view = data();
@let imgLink = imageLink();

<ng-template #tplAdvertisingDialog>
  <mat-dialog-content>
    @if (view.image; as image) {
      @if (imgLink; as imgLink) {
        <a uiNavLink [link]="imgLink" [matDialogClose]="'link'">
          <ui-image [data]="image"></ui-image>
        </a>
      } @else {
        <ui-image [data]="image"></ui-image>
      }
    } @else if (view.icon) {
      <ui-icon [faStyle]="view.icon.style" [faName]="view.icon.name"></ui-icon>
    }

    @if (view.headline) {
      <h2>{{ view.headline }}</h2>
    }

    @if (view.text) {
      <p>{{ view.text }}</p>
    }

    @if (view.link; as link) {
      @if (link.label; as label) {
        <ui-button-link buttonStyle="outlined" [link]="link" [matDialogClose]="'link'">{{ label }}</ui-button-link>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <ui-button buttonStyle="text" [matDialogClose]="'close'">Schließen</ui-button>
    @if (view.repeatInterval) {
      <ui-button buttonStyle="text" [matDialogClose]="'later'">Erneut anzeigen</ui-button>
    }
  </mat-dialog-actions>
</ng-template>
